/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProvisionChangeDto } from './ProvisionChangeDto';
import {
    ProvisionChangeDtoFromJSON,
    ProvisionChangeDtoFromJSONTyped,
    ProvisionChangeDtoToJSON,
    ProvisionChangeDtoToJSONTyped,
} from './ProvisionChangeDto';

/**
 * 
 * @export
 * @interface ParagraphChangeDto
 */
export interface ParagraphChangeDto {
    /**
     * 
     * @type {string}
     * @memberof ParagraphChangeDto
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof ParagraphChangeDto
     */
    number: number;
    /**
     * 
     * @type {string}
     * @memberof ParagraphChangeDto
     */
    title: string;
    /**
     * 
     * @type {Array<ProvisionChangeDto>}
     * @memberof ParagraphChangeDto
     */
    provisions: Array<ProvisionChangeDto>;
}

/**
 * Check if a given object implements the ParagraphChangeDto interface.
 */
export function instanceOfParagraphChangeDto(value: object): value is ParagraphChangeDto {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('provisions' in value) || value['provisions'] === undefined) return false;
    return true;
}

export function ParagraphChangeDtoFromJSON(json: any): ParagraphChangeDto {
    return ParagraphChangeDtoFromJSONTyped(json, false);
}

export function ParagraphChangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParagraphChangeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'number': json['number'],
        'title': json['title'],
        'provisions': ((json['provisions'] as Array<any>).map(ProvisionChangeDtoFromJSON)),
    };
}

export function ParagraphChangeDtoToJSON(json: any): ParagraphChangeDto {
    return ParagraphChangeDtoToJSONTyped(json, false);
}

export function ParagraphChangeDtoToJSONTyped(value?: ParagraphChangeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'number': value['number'],
        'title': value['title'],
        'provisions': ((value['provisions'] as Array<any>).map(ProvisionChangeDtoToJSON)),
    };
}

